// extracted by mini-css-extract-plugin
module.exports = {"header":"Localisation_header__35UKv","divider":"Localisation_divider__eL6xg","info":"Localisation_info__32g5p","wrapper":"Localisation_wrapper__1h2DQ"};